/**
 * YugOS landing page — one continuous cinematic experience.
 * Warm editorial paper, dark narrative interludes, and the product as hero.
 * Sections live in components/landing/sections; motion primitives in cinematic.jsx.
 */
import React from "react";
import { ScrollProgress, ClickRipple } from "@/components/landing/cinematic";
import Nav from "@/components/landing/sections/Nav";
import Hero from "@/components/landing/sections/Hero";
import Problem from "@/components/landing/sections/Problem";
import Story from "@/components/landing/sections/Story";
import Brain from "@/components/landing/sections/Brain";
import Explorer from "@/components/landing/sections/Explorer";
import BeforeAfter from "@/components/landing/sections/BeforeAfter";
import Flow from "@/components/landing/sections/Flow";
import Footer from "@/components/landing/sections/Footer";

export default function LandingPage() {
    return (
        <div className="landing-theme min-h-screen overflow-x-clip antialiased" data-testid="landing-page">
            <ScrollProgress />
            <ClickRipple />
            <Nav />
            <main>
                <Hero />
                <Problem />
                <Story />
                <Brain />
                <Explorer />
                <BeforeAfter />
                <Flow />
            </main>
            <Footer />
        </div>
    );
}
